import { EventEntity } from '../apis/event/event-entity';
import { UserEntity } from '../apis/user/user-entity';
import { VenueEntity } from '../apis/venue/venue-entity';
import { GroupEntity } from '../apis/group/group-entity';
import { ScheduleEntity } from '../apis/schedule/schedule-entity';
import { EventCommentEntity } from '../apis/event/event-comment-entity';

export class Project {
    public event: EventEntity = new EventEntity();
    public user: UserEntity = new UserEntity();
    public schedules: ScheduleEntity[] = [];
    public venues: VenueEntity[] = [];
    public groups: GroupEntity[] = [];
    public comments: EventCommentEntity[] = [];

    constructor(event: EventEntity, venues: VenueEntity[], groups: GroupEntity[], schedules: ScheduleEntity[], comments: EventCommentEntity[] = []) {
        this.event = event;
        this.venues = venues;
        this.groups = groups;
        this.schedules = schedules;
        this.comments = comments;
    }
}
